import React from 'react'
import './upcoming.css'
import ME from '../../assets/soon.png'
import {FaAward} from 'react-icons/fa'
import {FiUsers} from 'react-icons/fi'
import {VscFolderLibrary} from 'react-icons/vsc'

const Upcoming = () => {
  return (
    <section id='upcoming'>
      <h5>Here's the</h5>
      <h2>Upcoming</h2>

      <div className="container about__container">
        <div className="shorts__me">
          <div className="shorts__me-image">
            <img src={ME} alt="About Image" />
          </div>
        </div>
        <div className="about__content">
          
          <blockquote>
          Are you looking for fresh and exciting content on Python, AI tools, and other technical subjects? Our YouTube channel has you covered! We're currently working on some amazing new playlists that will explore the latest developments in these areas and beyond.

While we can't reveal all the details just yet, we promise that our upcoming playlists will be packed with informative and entertaining content that will help you stay ahead of the curve in the tech world. From beginner-friendly tutorials to in-depth analyses of cutting-edge technologies, we're confident that our new playlists will have something for everyone.

So if you're a tech enthusiast looking for fresh insights and ideas, stay tuned for our upcoming playlists! We'll be announcing more details soon, so don't forget to subscribe and hit the notification bell to be the first to know when our new content goes live. Get ready to learn, be inspired, and have some fun along the way!











          </blockquote>
          <br />
            <a href="https://www.youtube.com/@ataglanceofficial/" target="_blank" className='btn btn-primary'>Subscribe to stay updated!</a>
        </div>
      </div>
    </section>
  )
}

export default Upcoming